import { hasHoursQuota, usageRatio, formatHoursUsed, formatHoursQuota } from '../../lib/usage.js'

export default function UsageChip({ usage }) {
  if (!hasHoursQuota(usage)) return null
  const ratio = usageRatio(usage)
  let cls = 'text-muted'
  if (ratio >= 1) cls = 'text-terra-600 font-semibold'
  else if (ratio >= 0.8) cls = 'text-amber-700'
  return (
    <span className={`hidden text-[12px] tabular-nums sm:inline ${cls}`}>
      {formatHoursUsed(usage.monthly_seconds_used)} / {formatHoursQuota(usage.monthly_seconds_quota)}
    </span>
  )
}
